const Homeunbundl = () => import( /* webpackChunkName: 'wxmenu' */ './homeunbundl');

const routes = [{
  path: '/homeunbundl/homeunbundl',
  component: Homeunbundl,
  name: 'home-unbundl'
}];

export default routes;
